
import { default as axios } from 'axios';
import { saveAs } from 'file-saver';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IAggregateResultItemHypermediaRepresentation } from "../../shared/contracts/AggregateContract";
import { IMemberWithoutBarometerHypermediaRepresentation } from "../../shared/contracts/MemberContract";
import { ISnapshotHypermediaRepresentation } from "../../shared/contracts/SnapshotContract";
import { eventService } from "../../shared/services/EventService";
import JoeyLoading from "../shared/JoeyLoading.vue";
import DashboardPeopleActions from "./DashboardPeopleActions.vue";

@Component({
    components: {
        DashboardPeopleActions,
        JoeyLoading
    }
})

export default class BarometerCollection extends Vue {

  @Prop() actionSnapshots!: ISnapshotHypermediaRepresentation[];
  @Prop() areActionsLoading!: boolean;
  @Prop() areMembersLoading!: boolean;
  @Prop() totalNumberOfSnapshots: Number;
  @Prop() aggregateItem: IAggregateResultItemHypermediaRepresentation;
  @Prop() membersWithoutBarometer: IMemberWithoutBarometerHypermediaRepresentation[];

  public async exportPeople() {
        eventService.track('Export', 'My People');
        const result = await axios.get(this.aggregateItem._links.item_people_export.href);
        const contentDisposition = result.headers['content-disposition'];
        const filename = contentDisposition
            ? /filename[^;=\n]*="((['"]).*?\2|[^;\n]*)"/.exec(contentDisposition)[1]
            : 'export.csv';
        saveAs(new Blob(['\ufeff', result.data]), filename);
    }

}
